'use strict';

const kdContextError = require('./kd-context');

/**
 * Configuration Error
 *
 * This error denotes a Configuration Error, usually thrown when an
 * expected configuration value is missing or invalid.
 *
 * If `context` is provided, it should contain the invalid configuration
 * data and the context of the configuration (component, process, etc)
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} context - Configuration context data
 */
class ConfigurationError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'ConfigurationError';
        this.status = 500;
    }
}

module.exports = ConfigurationError;



/** WEBPACK FOOTER **
 ** ./src/common/error/configuration.js
 **/